import { useContext } from "react";
import { useSelector } from "react-redux";
import { RemoveOrganizationalUnitError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: RemoveOrganizationalUnitError;
  removeOrganizationalUnit(
    request: Boundaries["removeOrganizationalUnit"]["request"],
  ): void;
}

function useRemoveOrganizationalUnit(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRemoveOrganizationalUnitRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRemoveOrganizationalUnitRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRemoveOrganizationalUnitRequestFailure,
    ),
    error: useSelector(selector.getRemoveOrganizationalUnitError),
    removeOrganizationalUnit: core.removeOrganizationalUnit,
  };
}

export { useRemoveOrganizationalUnit };
